"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SettlementMoment;
(function (SettlementMoment) {
    SettlementMoment["OFFER_ACCEPTED"] = "offer_accepted";
    SettlementMoment["COOLDOWN_END"] = "cooldown_end";
    SettlementMoment["CONTRACT_START"] = "contract_start";
})(SettlementMoment || (SettlementMoment = {}));
exports.default = SettlementMoment;
